import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { environment } from '@environments/environment';
import { AccountService } from './account.service';
import { Role } from '@enums/role.enum';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';


@Injectable({
  providedIn: 'root'
})
export class UiService {
  environment = this.envConfigurationService.environment;

  isRouteLoading = new BehaviorSubject<boolean>(false);
  visibleSplashScreen = new BehaviorSubject<boolean>(false);

  private counterLoadingRoute = 0;

  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private accountService: AccountService,
    private router: Router,
    public envConfigurationService: EnvConfigurationService
  ) {
    // this._init();
  }

  private _init(): void {

    // If the splash screen element exists...
    // Hide it on the first NavigationEnd event
    this.router.events
      .pipe(
        filter((event => event instanceof NavigationEnd)),
        take(1)
      )
      .subscribe(() => {
        setTimeout(() => {
          this.showSplashScreen(false);
        });
      });
  }


  showSplashScreen(visible: boolean) {
    this.visibleSplashScreen.next(visible);
  }

  addRouteLoading(): void {
    setTimeout(() => {
      this.counterLoadingRoute++;
      if (this.counterLoadingRoute > 0) {
        this.setRouteLoading(true);
      }
    });
  }
  removeRouteLoading(): void {
    setTimeout(() => {
      this.counterLoadingRoute--;
      if (this.counterLoadingRoute <= 0) {
        this.setRouteLoading(false);
      }
    });
  }

  clearAllRouteLoading(): void {
    setTimeout(() => {
      this.counterLoadingRoute = 0;
      this.setRouteLoading(false);
    });
  }

  setRouteLoading(isRouteLoading: boolean): void {
    this.isRouteLoading.next(isRouteLoading);
  }

  displayMessageToast(message: string, panelClass?: string, action?: string, duration?: number) {
    this.translateService.get(message).subscribe((text: string) => {
      this.snackBar.open(text, action, {
        duration: duration || 2000,
        panelClass: panelClass ? [panelClass] : []
      });
    });
  }

  isDeclaration(): boolean {
    return this.environment.application == 'declaration';
  }
  isSupervision(): boolean {
    return this.environment.application == 'supervision';
  }
  visibleByRole(role: Role[]): boolean {
    return role.find(f => f == this.accountService.currentUser.value?.role_) != null;
  }

  getMinDate(): Date { 
    const _date = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
    return new Date(_date);
  };
  getMaxDate(): Date {
    const _date = new Date(new Date().setFullYear(new Date().getFullYear() + 100));
    return new Date(_date);
  };

}
